const translations = {
  // Navigation
  'nav.home': 'Inicio',
  'nav.records': 'Anson Road Records',
  'nav.licensingPublishing': 'Licencias + Publicación',
  'nav.management': 'Gestión',
  'nav.contact': 'Contacto',
  'nav.submitMusic': 'Enviar Música',

  // Hero Section
  'hero.tagline': 'Arraigados en Texas y moldeados por los sonidos de su cultura, Santos Music Group y Anson Road Records lanza música con carácter, corazón y camino recorrido — donde las viejas costumbres aún importan, y el próximo capítulo llega naturalmente.',
  'hero.exploreSound': 'Explora el Sonido',
  'hero.submitMusic': 'Enviar Música',
  'hero.scroll': 'Desliza',

  // About Section
  'about.quote1': '"La música country no llegó aquí — siempre ha estado aquí."',
  'about.paragraph1': 'A través de <strong>Texas,</strong>&nbsp;el Suroeste y el Norte de México, el sonido ha vivido cerca de la tierra — moldeado por pueblos trabajadores, carreteras fronterizas, salones de baile y generaciones de historias, desde ritmos de conjunto hasta caminos de arcilla roja.',
  'about.paragraph2': '<strong>Santos Music Group/Anson Road Records</strong>&nbsp;es un sello moderno de <strong>Texas Country y Latin Country</strong>&nbsp;dedicado a artistas que dicen la verdad — ya sea que su influencia venga en inglés o español, tradición Country, Tejano, Regional o Americana de caminos rurales. Honramos la música que siempre ha sido parte de esta tierra.',
  'about.paragraph3': 'A través de nuestra asociación con <strong>RanchFire Radio</strong>, conectamos a nuestros artistas directamente con los oyentes en Texas, el Suroeste y más allá — dándoles difusión, exposición y una plataforma construida para la música que importa. Es más que distribución — es una misión compartida para amplificar voces auténticas y mantener vivo el sonido donde pertenece: en la radio, en la camioneta y en el camino.',
  'about.quote2': '"Ponemos la canción primero. La música habla por sí misma."',

  // Divisions Section
  'divisions.title': 'Lo Que Hacemos',
  'divisions.records.title': 'División de Discos',
  'divisions.records.description': 'Lanzamientos selectos de artistas modernos de Texas Country que moldean la próxima era — honrando la tradición mientras construimos algo nuevo.',
  'divisions.publishing.title': 'División de Publicación',
  'divisions.publishing.description': 'Construcción de catálogo centrada en compositores, administración de derechos y valor a largo plazo para historias contadas en cualquier idioma.',
  'divisions.licensing.title': 'División de Licencias',
  'divisions.licensing.description': 'Música lista para sincronización en cine, TV, trailers, marcas y cultura — sonidos auténticos que conectan.',
  'divisions.management.title': 'Gestión de Artistas',
  'divisions.management.description': 'Desarrollo práctico, estrategia y orientación profesional para talentos emergentes de todos los orígenes.',
  'divisions.cta': 'Trabaja Con Unwound Sound',

  // Management Page
  'management.hero.title': 'Gestión de Artistas',
  'management.hero.intro': 'Trabajamos con un <strong>número pequeño de artistas</strong> a la vez — ayudando a desarrollar sonido, historia, estrategia de giras y posicionamiento a largo plazo.',
  'management.focus.title': 'Enfoque de Gestión:',
  'management.focus.strategy.title': 'Estrategia de Carrera',
  'management.focus.strategy.description': 'Visión a largo plazo y posicionamiento para crecimiento sostenible en el panorama moderno del Texas Country.',
  'management.focus.release.title': 'Planificación de Lanzamientos',
  'management.focus.release.description': 'Lanzamientos estratégicos, timing y coordinación en todas las plataformas y canales de medios.',
  'management.focus.brand.title': 'Asociaciones de Marca',
  'management.focus.brand.description': 'Colaboraciones auténticas con marcas patrimoniales, empresas de estilo de vida e instituciones culturales.',
  'management.focus.live.title': 'Crecimiento en Vivo + Festivales',
  'management.focus.live.description': 'Construcción de infraestructura de giras, presencia en festivales y fortalezas regionales en Texas y más allá.',
  'management.focus.crossBorder.title': 'Oportunidad Transfronteriza',
  'management.focus.crossBorder.description': 'Aprovechando las conexiones culturales Texas ↔ México para el desarrollo de artistas bilingües y biculturales.',
  'management.cta': 'Solicitar Gestión',

  // Artists Page
  'artists.hero.title': 'Roster y Envíos',
  'artists.hero.intro': 'Representamos un grupo selecto de escritores y artistas que crean el próximo capítulo de la música country auténtica.',
  'artists.roster.title': 'Escritores y Artistas Destacados',
  'artists.roster.subtitle': 'Un roster curado de talento creando alt-country auténtico y música arraigada en Texas.',

  // Licensing Page
  'licensing.hero.title': 'Licencias Musicales y Sincronización',
  'licensing.hero.intro': 'Unwound Sound ofrece un roster curado de grabaciones auténticas de alt-country y música arraigada en Texas disponibles para sincronización.',

  // Publishing Page
  'publishing.hero.title': 'Publicación y Composición',
  'publishing.hero.intro': 'Las grandes canciones son activos. Construimos catálogos que perduran.',

  // Records Page
  'records.hero.title': 'El Sello',
  'records.hero.intro': 'Anson Road Records es un hogar para artistas modernos de <strong>Texas Country</strong> que viven fuera del pulido — música que se siente real, vivida e innegable.',
  'records.hero.whatWeRelease': 'Lo Que Lanzamos',
  'records.hero.texasCountry': '<strong>Texas Country</strong> y Latino Country',
  'records.hero.altCountry': 'Alt-country y <strong>Americana</strong>',
  'records.hero.borderland': 'Narrativa <strong>fronteriza</strong>',
  'records.hero.crossover': 'Voces cruzadas moldeando el <strong>futuro</strong> del género',

  // Footer
  'footer.tagline': 'Sello Moderno de Texas Country',
  'footer.services': 'Música • Publicación • Licencias • Gestión de Artistas',
  'footer.slogan': 'Arraigados en Texas. Construidos para el largo camino. Para todos.',
  'footer.navigate': 'Navegar',
  'footer.stayConnected': 'Mantente Conectado',
  'footer.newsletterText': 'Recibe nuevos lanzamientos, música para sincronización y descubrimientos de artistas',
  'footer.emailPlaceholder': 'TU EMAIL',
  'footer.subscribe': 'Suscribirse',
  'footer.subscribing': 'Suscribiendo...',
  'footer.thankYou': '¡Gracias por suscribirte!',
  'footer.error': 'Algo salió mal. Intenta de nuevo.',
  'footer.copyright': '© 2026 Anson Road Records, subsidiaria de ranchfire multimedia, llc. Todos los Derechos Reservados.',
};

export default translations;
